import React from 'react'
import Balance from 'components/Balance'
import { GradientsFont } from 'components/Text/GradientsFont'
import { useTranslation } from 'contexts/Localization'
import { Link } from 'react-router-dom'
import { Card, Flex, Button, Text } from 'vvs-uikit'
import styled from 'styled-components'
import useTheme from 'hooks/useTheme'
import { useVaultsApr } from 'views/xVvs/hooks/useVaultsApr'

const StyledText = styled(Text)`
  margin-bottom: 12px;

  ${({ theme }) => theme.mediaQueries.xl} {
    margin-bottom: 0;
  }
`

const RecommendSection = () => {
  const { t } = useTranslation()
  const { theme } = useTheme()
  const vaultsApr = useVaultsApr()
  const earnMaxApr = vaultsApr.length === 0 ? 0 : Math.max(...vaultsApr.map((x) => Number(x.apr)))

  return (
    <Card p={0} mt={3} background={theme.colors.invertedContrast}>
      <Flex
        flexDirection={['column', 'column', 'column', 'column', 'column', 'row']}
        justifyContent="space-between"
        alignItems="center"
        p="24px"
      >
        <Flex flexDirection="column" maxWidth="370px">
          <Flex alignItems="center" justifyContent="flex-start">
            <Text small bold>
              {t('Boost Your Earnings')}
            </Text>
            <GradientsFont ml={2} bold small textTransform="uppercase" title={t('Recommended')}>
              {t('Recommended')}
            </GradientsFont>
          </Flex>
          <StyledText fontSize="13px" color="textSubtle" mr="4px">
            {t('Lock your xVVS into our vault to earn up to ')}
            <Balance fontSize="13px" bold color="text" value={earnMaxApr} decimals={2} unit="% APR!" display="inline" />
          </StyledText>
        </Flex>
        <Button
          as={Link}
          to="/xvvs/vault"
          style={{ fontSize: '14px' }}
          width={['100%', '100%', '100%', '100%', '100%', 'auto']}
        >
          {t('See Vault')}
        </Button>
      </Flex>
    </Card>
  )
}

export default RecommendSection
